import Vue from "vue"
import App from "./App.vue"
import store from "./store"
import VueCompositionAPI from "@vue/composition-api"
import Aegis from "@tencent/aegis-web-sdk"
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
window.APP_START_TIME = +new Date()

window.aegis = new Aegis({
  id: "6729",
  reportApiSpeed: true,
  reportAssetSpeed: true,
  api: {
    resourceTypeHandler(url) {
      if (url.indexOf("api.unipay.qq.com") > -1 || url.indexOf("pay.qq.com/cgi-bin/account") > -1) {
        return "fetch"
      }
    },
    retCodeHandler(data, url) {
      // 注意这里拿到的data是string类型，如果需要对象需要手动parse下
      if (data && url) {
        const result = {
          isErr: data?.ret != 0 || data?.resultcode != 0,
          code: data?.ret
        }
        return result
      }
    }
  }
})

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://0362eb185be64f80a8768acc04b7de2c@report.url.cn/sentry/971",
    environment: process.env.NODE_ENV,
    release: "1.0.0",
    tags: { page: "team_pk" },
    sampleRate: process.env.NODE_ENV != "production" ? 1 : 0.2,
    beforeSend: event => {
      if (process.env.NODE_ENV != "production") {
        console.log(event)
        return null
      }
      return event
    },

    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })
}

Vue.use(VueCompositionAPI)

Vue.config.devtools = process.env.NODE_ENV === "development"

new Vue({
  el: "#app",
  render: h => h(App),
  store: store
})
